"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CloseIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-979.000000, -237.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(978.000000, 237.000000)",
        fill: color,
        fillRule: "nonzero",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M1.29289322,0.292893219 C1.65337718,-0.0675907428 2.22060824,-0.0953202783 2.61289944,0.209704612 L2.70710678,0.292893219 L18.7071068,16.2928932 C19.0976311,16.6834175 19.0976311,17.3165825 18.7071068,17.7071068 C18.3466228,18.0675907 17.7793918,18.0953203 17.3871006,17.7902954 L17.2928932,17.7071068 L1.29289322,1.70710678 C0.902368927,1.31658249 0.902368927,0.683417511 1.29289322,0.292893219 Z"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M17.2928932,0.292893219 C17.6834175,-0.0976310729 18.3165825,-0.0976310729 18.7071068,0.292893219 C19.0675907,0.65337718 19.0953203,1.22060824 18.7902954,1.61289944 L18.7071068,1.70710678 L2.70710678,17.7071068 C2.31658249,18.0976311 1.68341751,18.0976311 1.29289322,17.7071068 C0.932409257,17.3466228 0.904679722,16.7793918 1.20970461,16.3871006 L1.29289322,16.2928932 L17.2928932,0.292893219 Z"
        })]
      })
    })
  })]
});

CloseIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = CloseIcon;
exports.default = _default;